import { graphql } from '@/gql';
import type { PaginationInputType } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedGroceryTypeResponse } from '@/models/grocery';

export const fetchIncomingGroceries = async ({
  searchType,
  searchValue,
  pagination,
}: {
  searchType?: string;
  searchValue?: string;
  pagination: PaginationInputType;
}): Promise<PaginatedGroceryTypeResponse> => {
  const response = await queryExecute({
    variables: {
      searchType,
      searchValue,
      pagination,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query IncomingGroceries($searchType: String, $searchValue: String, $pagination: PaginationInputType) {
        incomingGroceries(searchType: $searchType, searchValue: $searchValue, pagination: $pagination) {
          rows {
            id
            name
            orderId
            cartId
            orderUUId
            callerId
            customerName
            timeZone
            email
            address
            priorityLevel
            status
            currency
            notes
            orderNotes
            transactionId
            instruction
            userId
            orderedByName
            timeReceived
            timeShopping
            timeShoppingComplete
            timeInTransit
            timeCompleted
            timeCanceled
            paidStatus
            canceledBy
            canceledById
            canceledByName
            reasonForCanceling
            noGoGoFee
            noGoGoFeeReason
            tip
            totalCost
            gogoFee
            gogoCost
            discount
            isTipable
            isSavedGrocery
            assignedOperatorId
            isConfirmedAddressAndNotes
            isInteractedWithShopper
            preauthChargeAmount
            driverId
            groceryStoreId
            storeName
            storeLogo
            driverName
            initialEstimateStartAt
            initialEstimateEndAt
            estimateStartAt
            estimateEndAt
            chatLink
            createdAt
            updatedAt
            store {
              id
              name
              slug
              logo
              createdAt
              updatedAt
            }
            driver {
              id
              firstName
              photo
            }
            caller {
              id
              firstName
              lastName
              email
              phoneNumber
            }
            assignedOperator {
              id
              firstName
              lastName
            }
          }
          count
        }
      }
    `),
  });

  return response.data.incomingGroceries;
};
